import { render } from "./LectureViewReportT.vue?vue&type=template&id=4b3ca2ba&scoped=true"
import script from "./LectureViewReportT.vue?vue&type=script&lang=js"
export * from "./LectureViewReportT.vue?vue&type=script&lang=js"

import "./LectureViewReportT.vue?vue&type=style&index=0&id=4b3ca2ba&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3ca2ba"]])

export default __exports__